import { useContext } from 'react'
import { AgendaContext } from '..'

export const StaticsDay = () => {
  const { statics } = useContext(AgendaContext)
  return (
    <div className="flex flex-col justify-center bg-gray-200 p-6 gap-5  rounded-lg">
      <ul
        style={{
          padding: 0,
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        <p
          style={{
            fontWeight: 'bold',
            textAlign: 'center',
            fontSize: '1.0rem',
          }}
        >
          Hoje
        </p>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontWeight: 'bold',
          }}
        >
          <p style={{ margin: 0 }}>Agendamentos</p>{' '}
          <p style={{ margin: 0 }}>{statics.agendamentos}</p>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <p
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '7px',
              margin: 0,
            }}
          >
            <div
              style={{
                width: '10px',
                height: '10px',
                backgroundColor: '#D4D672',
                borderRadius: '100px',
              }}
            />
            Iniciado
          </p>
          <p style={{ margin: 0 }}>{statics.preparacao}</p>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <p
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '7px',
              margin: 0,
            }}
          >
            <div
              style={{
                width: '10px',
                height: '10px',
                backgroundColor: '#2893B5',
                borderRadius: '100px',
              }}
            />
            Confirmados
          </p>
          <p style={{ margin: 0 }}>{statics.confirmados || 0}</p>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <p
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '7px',
              margin: 0,
            }}
          >
            <div
              style={{
                width: '10px',
                height: '10px',
                backgroundColor: '#E63842',
                borderRadius: '100px',
              }}
            />
            Aguardando
          </p>
          <p style={{ margin: 0 }}>{statics.aguardando || 0}</p>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <p
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '7px',
              margin: 0,
            }}
          >
            <div
              style={{
                width: '10px',
                height: '10px',
                backgroundColor: '#1A9042',
                borderRadius: '100px',
              }}
            />
            Atendido
          </p>
          <p style={{ margin: 0 }}>{statics.atendido || 0}</p>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <p
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '7px',
              margin: 0,
            }}
          >
            <div
              style={{
                width: '10px',
                height: '10px',
                backgroundColor: 'white',
                borderRadius: '100px',
              }}
            />
            Concluído
          </p>
          <p style={{ margin: 0 }}>{statics.finalizado || 0}</p>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <p
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '7px',
              margin: 0,
            }}
          >
            <div
              style={{
                width: '10px',
                height: '10px',
                backgroundColor: '#D0D0D0',
                borderRadius: '100px',
              }}
            />
            Cancelado
          </p>
          <p style={{ margin: 0 }}>{statics.cancelado || 0}</p>
        </div>
      </ul>
    </div>
  )
}
